<template>
    <div>
        <loading-spinner class="loading-spinner" v-if="loading" />

        <div v-else>
            <b-card no-body class="card-container">
                <template v-slot:header>
                    <div class="justify-content-between align-items-center">
                        <b-row>
                            <b-col>
                                <h1>Roles and permission managment</h1>
                            </b-col>

                            <b-col>
                                <span v-if="saving">
                                    <b-spinner
                                        variant="success"
                                        label="Spinning"
                                        small
                                    ></b-spinner>
                                </span>
                                <strong v-if="saved" class="text-success">
                                    Permissions have been updated
                                </strong>
                            </b-col>

                            <b-col class="text-right">
                                <b-button
                                    @click="$bvModal.show('role_edit_new')"
                                    variant="outline-primary"
                                    class="btn-round mr-2"
                                >
                                    <font-awesome-icon :icon="['fas', 'plus']" />
                                    Create new role
                                </b-button>

                                <b-button
                                    @click="saveRoles"
                                    :disabled="saving"
                                    variant="primary"
                                    class="btn-round"
                                >
                                    Save
                                </b-button>

                                <permissions-edit-role
                                    @saved="loadRoles"
                                ></permissions-edit-role>
                            </b-col>
                        </b-row>
                    </div>
                </template>

                <b-card-body>
                    <b-table-simple
                        sticky-header="calc(100vh - 215px)"
                        small
                        responsive
                        hover
                        :busy="loading"
                    >
                        <b-thead>
                            <b-tr>
                                <b-th sticky-column>Permission</b-th>
                                <b-th v-for="role in roles" :key="role.id"
                                    >{{ role.name }}
                                    <a
                                        href="#"
                                        size="sm"
                                        @click="$bvModal.show('role_edit_' + role.id)"
                                    >
                                        Edit
                                    </a>
                                    <edit-role
                                        :role-id="role.id"
                                        :role-name.sync="role.name"
                                    ></edit-role>
                                </b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr
                                v-for="permission in permissions"
                                :key="permission.id"
                            >
                                <b-td
                                    sticky-column
                                    role="row"
                                    class="text-nowrap text-capitalize"
                                    >{{ permission.name }}</b-td
                                >
                                <b-td v-for="role in roles" :key="role.id">
                                    <b-form-checkbox
                                        @change="saveRoles"
                                        v-model="checkedPermissions[role.id]"
                                        :name="'permissions_' + role.id + '_' + permission.id"
                                        :value="permission.id"
                                    ></b-form-checkbox>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card-body>
            </b-card>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import EditRole from "./EditRole";
import LoadingSpinner from "../Common/LoadingSpinner";

export default {
  name: "PermissionsRolesManagement",
  components: { EditRole, LoadingSpinner },
  data() {
    return {
      roles: null,
      permissions: null,
      loading: true,
      saving: false,
      saved: false,
      checkedPermissions: {}
    };
  },
  computed: {},
  mounted() {
    Promise.all([this.loadRoles(), this.loadPermissions()]).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    saveRoles: _.debounce(function() {
      this.saving = true;
      axios
        .post("/api/roles/batch", {
          roles: this.checkedPermissions
        })
        .finally(() => {
          this.saving = false;
          this.saved = true;
        });
    }, 500),
    loadRoles() {
      return axios.get("/api/roles?noPagination").then(r => {
        this.roles = r.data.data;
        let checked = {};
        this.roles.forEach(r => {
          const permissionIds = r.permissions.map(p => p.id);
          checked[r.id] = permissionIds;
        });
        this.checkedPermissions = checked;
      });
    },
    loadPermissions() {
      return axios.get("/api/permissions?noPagination").then(r => {
        this.permissions = r.data.data;
      });
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 20px;
  margin-top: 9px;
  margin-bottom: 9px;
}

.table thead th {
  font-size: 15px;
  border-bottom: 1px solid #dee2e6;
}

.table td,
.table th {
  text-align: center;
}

.table td:first-child,
.table th:first-child {
  text-align: left !important;
}
</style>
